import { Actions } from './contact-titles.actions'
import { fromJS } from 'immutable'
import * as ContactTitlesTypes from './contact-titles.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    total: 0,
    results: 0,
  },
  createContactTitle: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateContactTitle: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function contactTitlesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ContactTitlesTypes.UPDATE_CONTACT_TITLE_REQUEST: {
      return state.setIn(['updateContactTitle', 'isLoading'], true)
    }

    case ContactTitlesTypes.UPDATE_CONTACT_TITLE_SUCCESS: {
      return state.setIn(['updateContactTitle', 'isLoading'], false)
    }

    case ContactTitlesTypes.UPDATE_CONTACT_TITLE_FAILURE: {
      return state.setIn(['updateContactTitle', 'isLoading'], false)
    }

    case ContactTitlesTypes.CREATE_CONTACT_TITLE_REQUEST: {
      return state.setIn(['createContactTitle', 'isLoading'], true)
    }

    case ContactTitlesTypes.CREATE_CONTACT_TITLE_SUCCESS: {
      return state.setIn(['createContactTitle', 'isLoading'], false)
    }

    case ContactTitlesTypes.CREATE_CONTACT_TITLE_FAILURE: {
      return state.setIn(['createContactTitle', 'isLoading'], false)
    }

    case ContactTitlesTypes.DELETE_CONTACT_TITLE_REQUEST: {
      return state
    }

    case ContactTitlesTypes.DELETE_CONTACT_TITLE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case ContactTitlesTypes.DELETE_CONTACT_TITLE_FAILURE: {
      return state
    }

    case ContactTitlesTypes.FETCH_CONTACT_TITLES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case ContactTitlesTypes.FETCH_CONTACT_TITLES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case ContactTitlesTypes.FETCH_CONTACT_TITLES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case ContactTitlesTypes.FETCH_CONTACT_TITLE_REQUEST: {
      return state.setIn(['updateContactTitle', 'isLoading'], true)
    }

    case ContactTitlesTypes.FETCH_CONTACT_TITLE_SUCCESS: {
      return state
        .setIn(['updateContactTitle', 'isLoading'], false)
        .setIn(
          ['updateContactTitle', 'data'],
          fromJS(action.payload).delete('contactTitle').delete('id'),
        )
    }

    case ContactTitlesTypes.FETCH_CONTACT_TITLE_FAILURE: {
      return state.setIn(['updateContactTitle', 'isLoading'], false)
    }

    case ContactTitlesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case ContactTitlesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
